import { getRandomNumber } from './NumberUtils';

// A simple utility function to capitalize the first letter of a string.
export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const convertShortToLong = (short: string) => {
  switch (short) {
    case 'g':
      return 'grams';
    case 'kg':
      return 'kilograms';
    case 'lb':
      return 'pounds';
    case 'oz':
      return 'ounces';
    case 'm':
      return 'meters';
    case 'km':
      return 'kilometers';
    case 'ft':
      return 'foot';
    case 'mi':
      return 'miles';
    default:
      break;
  }
};

export const getRandomStringFromArr = (arr: string[0]) => {
  return arr[getRandomNumber(0, arr.length - 1)];
};

export const getThemeColour = (number: number) => {
  switch (number) {
    case 0:
      return 'default';
    case 1:
      return 'green';
    case 2:
      return 'blue';
    case 3:
      return 'red';
    default:
      return 'default';
  }
};

export const generateLoremIpsum = (words: number) => {
  const loremIpsum =
    'Ullamco voluptate commodo mollit veniam laborum ullamco irure do nulla magna ut proident commodo esse. Nostrud amet consectetur exercitation cillum.Minim cupidatat ad deserunt magna proident dolore ipsum exercitation quis tempor aliquip Lorem minim ea. Cupidatat excepteur do culpa eu quis Lorem.';
  const loremIpsumWords = loremIpsum.split(' ');
  const result = [];

  for (let i = 0; i < words; i++) {
    const randomIndex = Math.floor(Math.random() * loremIpsumWords.length);
    result.push(loremIpsumWords[randomIndex]);
  }

  return result.join(' ');
};

// Function to generate a random array of characters
export const getRandomArray = (originalArray: string[], length: number) => {
  const randomArray = [];
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * originalArray.length);
    randomArray.push(originalArray[randomIndex]);
  }
  return randomArray;
};

export function shuffleArray(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]]; // Swap elements
  }
}

export function createRandomPairs(chars, nums) {
  // Create pairs where the number or character can come first
  const pairs = [];
  for (let i = 0; i < chars.length; i++) {
    if (Math.random() > 0.5) {
      pairs.push(nums[i] + chars[i]); // Number first
    } else {
      pairs.push(chars[i] + nums[i]); // Character first
    }
  }

  // Shuffle the pairs array
  shuffleArray(pairs);

  return pairs;
}

export const areArraysEqual = (array1: string[], array2: string[]): boolean => {
  if (array1.length !== array2.length) {
    return false; // Arrays must have the same length to be equal
  }

  return array1.every((value, index) => value === array2[index]);
};
